// @param {number} codedInt
// @param {number} bitMask
// @param {boolean} isOn
// @returns {int}
export function encodeBitMask(codedInt, bitMask, isOn) {
  if (isOn) {
    codedInt |= bitMask; 
  } else {
    codedInt &= ~bitMask; 
  }
  return codedInt;
}

// @param {number} value
// @param {number} bitMask
// @returns {boolean}
export function decodeBitMask(value, bitMask) {
  return (value & bitMask) !== 0;
}